import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import type { Leader } from "@/lib/types/content";

export function ReadBioButton({ leader: l, variant = "outline" }: { leader: Leader; variant?: "outline" | "ghost" }) {
  const styles =
    variant === "ghost"
      ? "inline-flex items-center gap-1 text-base font-semibold text-primary hover:underline"
      : "inline-flex items-center gap-1.5 rounded-md border border-primary bg-transparent px-4 py-2 text-base font-semibold text-primary transition hover:bg-primary hover:text-primary-foreground";
  return (
    <Link to="/leadership/$slug" params={{ slug: l.slug }} className={styles}>
      Read bio <ArrowRight className="h-3.5 w-3.5" />
    </Link>
  );
}
